/**
 * Formats a date-only value (YYYY-MM-DD or ISO datetime) for display
 * without timezone shifting the calendar day.
 */
export function formatDateOnly(
  dateValue,
  locale = undefined,
  options = undefined
) {
  if (!dateValue) {
    return null;
  }

  const [year, month, day] = String(dateValue)
    .split("T")[0]
    .split("-")
    .map(Number);

  if (!year || !month || !day) {
    return null;
  }

  return new Date(year, month - 1, day).toLocaleDateString(locale, options);
}
